import React from 'react';
import {
  Badge,
  Box,
  Divider,
  Flex,
  Typography,
  AnimatedCounter,
  Vanish,
  getTeeColor,
} from '@slope/uikit';
import { TeeColor } from '@slope/graphql/resolvers';

export type HoleInfoProps = {
  number: number | string;
  strokeIndex: number | string;
  par: number | string;
  distance: number | string;
  color: TeeColor;
};

export const HoleInfo: React.FC<HoleInfoProps> = ({
  number,
  par,
  strokeIndex,
  distance,
  color,
}) => (
  <Flex
    inline
    flexDirection="column"
    alignItems="center"
    textShadow="white -1px -1px 0px, white 1px -1px 0px, white -1px 1px 0px, white 1px 1px 0px"
  >
    <Flex flexDirection="row" gap="0.5rem" alignItems="center">
      <AnimatedCounter value={number} delay={0} fontSize={[4, 6]} fontWeight={500} />
      <Flex>
        <Flex
          gap="0.5rem"
          flexDirection="row"
          fontSize={[2, 3]}
          justifyContent="center"
          alignItems="center"
        >
          <Vanish timeout={5000} inline>
            <Typography>Par</Typography>
          </Vanish>
          <AnimatedCounter value={par} delay={0} />
        </Flex>
        <Flex
          gap="0.5rem"
          flexDirection="row"
          fontSize={[1, 2]}
          justifyContent="center"
          alignItems="center"
        >
          <Vanish timeout={5000} inline>
            <Typography>Hcp</Typography>
          </Vanish>
          <AnimatedCounter value={strokeIndex} delay={0} />
        </Flex>
      </Flex>
    </Flex>
    <Divider />
    <Flex gap="0.5rem" flexDirection="row" alignItems="center" justifyContent="center">
      <Box fontSize={[2, 3]}>
        <AnimatedCounter value={distance} delay={0} inline />
        <Vanish key={distance} timeout={5000} inline>
          <Typography>m</Typography>
        </Vanish>
      </Box>
      <Badge bg={getTeeColor(color)} size="16px" />
    </Flex>
  </Flex>
);
